import React, {
  useEffect,/* , useState */
  useState
} from 'react';
import { FormControl, FormHelperText, Grid, InputLabel, Select, } from '@material-ui/core';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
//import { Autocomplete } from '@mui/material';
import { hasError, LABEL_INPUT_FONT_SIZE, validateField } from '../../ConstsAndUtils/utils';

const DireccionPrestador = props => {
  const {
    listaRegiones,
    listaComunas,
    listaCiudades,
    listaProvinciasWithId,
    /*   listaComunasWithId, */
    setComunaList,
    setCiudadesList,
    /* servicioSaludList, */
    servicioSaludListWithId,
    setDireCompleta,
  } = props;
  const {
    nombreCalle,
    setNombreCalle,
    numeroCalle,
    setNumeroCalle,
    comuna,
    setComuna,
    ciudad,
    setCiudad,
    region,
    setRegion,
    servicioSalud,
    setServicioSalud,
  } = props;

  const [listaServiciosSalud, setListaServiciosSalud] = useState([])
  const [numeroCalleError, setNumeroCalleError] = useState('')
  const [nombreCalleError, setNombreCalleError] = useState('')
  const [provinciaError, setProvinciaError] = useState('')
  const [comunaError, setComunaError] = useState('')
  const [servicioSaludError, setServicioSaludError] = useState('')


  useEffect(() => {
    if (region !== '') {
      let aux = listaProvinciasWithId.find(prov => prov.region_nombre === region);
      let auxServSal = servicioSaludListWithId.find(serv => serv.region.region_nombre === region)
      let idRegion = auxServSal.id_region
      let listServs = servicioSaludListWithId.filter(serv => serv.id_region === idRegion)
      setListaServiciosSalud(listServs)
      setCiudadesList(aux.provincias)

    }
    // eslint-disable-next-line
  }, [region])

  useEffect(() => {
    if (ciudad !== '0a') {
      let provincias = listaProvinciasWithId.find(prov => prov.region_nombre === region);
      let provinciaSeleccionada = provincias.provincias.find(prov => prov.provincia_id === parseInt(ciudad))
      if (provinciaSeleccionada) {
        setComunaList(provinciaSeleccionada.comunas)
      }
    } else {
      setComuna('0a');
      setProvinciaError('Campo obligatorio')
      setComunaError('Campo obligatorio')
      setNombreCalleError('Campo obligatorio')
      setNumeroCalleError('Campo obligatorio')
    }
    // eslint-disable-next-line
  }, [ciudad])

  useEffect(() => {
    if (comuna !== '0a') {

    } else {
      setNumeroCalle('')
      setNombreCalle('')
      setComunaError('Campo Obligatorio')
      setNombreCalleError('Campo obligatorio')
      setNumeroCalleError('Campo obligatorio')
    }
    // eslint-disable-next-line
  }, [comuna])

  const dispatchRegionChange = newValue => {
    setRegion(newValue);
    setComuna('0a');
    setCiudad('0a');
    setServicioSalud('0a')
    setNombreCalle('')
    setNumeroCalle('')
    setProvinciaError('Campo obligatorio')
    setComunaError('Campo obligatorio')
    setServicioSaludError('Campo obligatorio')
    setNombreCalleError('Campo obligatorio')
    setNumeroCalleError('Campo obligatorio')
  };

  const getOptionsCiudades = () => {
    return listaCiudades.map((item, index) => {
      return <option key={index} value={item.provincia_id}>
        {item.provincia_nombre}
      </option>
    })
  }

  const getOptionsComunas = () => {

    return listaComunas.map((item, index) => {
      return <option key={index} value={item.comuna_id}>
        {item.comuna_nombre}
      </option>
    })
  }

  const getServiciosSaludOpts = () => {
    return listaServiciosSalud.map((item, index) => {
      return <option key={index} value={item.id}>
        {item.servicio_salud}
      </option>
    })
  }

  const validateNCalle = (input) => {
    const isEmpty = input === ''
    const isValidNumber = /^[1-9]\d*$/.test(input)
    const isValidSn = /^(s\/n|s\/|s)$/.test(input)

    return isEmpty || isValidNumber || isValidSn;
  }
  return (
    <Grid
      container
      item
      xs={12}
      spacing={4}
      style={{
        backgroundColor: 'white',
        paddingTop: 5,
        borderRadius: 5,
        paddingBottom: 5,
        marginTop: 15,
        paddingLeft:15,
        paddingRight:15,
        marginLeft:1,
        marginRight:1
      }}>
      <Grid item xs={12}>
        <h3>Dirección del prestador</h3>
      </Grid>

      {listaRegiones.length === 0 ?


        null
        :
        <Grid item xs={4}>
          <FormControl size="small" fullWidth>
            <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
              {"Región"}
            </InputLabel>
            <Select
              label="Región"
              value={region}
              native
              id="grouped-native-select"
              fullWidth
              variant='outlined'
              onChange={(e) => {
                dispatchRegionChange(e.target.value);
              }}
            >
              {
                listaRegiones.map((item, index) => {
                  return <option key={index} value={item}>
                    {item}
                  </option>
                })
              }
            </Select>
          </FormControl>

        </Grid>
      }

      <Grid item xs={4}>
        <FormControl size="small" fullWidth error={hasError(provinciaError)}>
          <InputLabel
            htmlFor="grouped-native-select"
            style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}
          >
            {'Provincia'}
          </InputLabel>
          <Select
            disabled={region === '' ? true : false}
            value={ciudad}
            native
            label={'Provincia'}
            id="grouped-native-select"
            fullWidth
            variant='outlined'
            style={{ color: hasError(provinciaError) ? 'red' : 'inherit' }}
            onChange={(e) => {
              setComuna('0a')
              setNumeroCalle('')
              setNombreCalle('')
              if (e.target.value !== '0a') {
                setCiudad(e.target.value);
                setProvinciaError('')
                setComunaError('Campo obligatorio')
                setNombreCalleError('Campo obligatorio')
                setNumeroCalleError('Campo obligatorio')
              } else {
                setCiudad('0a');

              }
            }}
          >
            <option key={'0a'} value={'0a'}>Seleccione</option>
            {
              region === '' ? null :
                getOptionsCiudades()
            }
          </Select>
          <FormHelperText>{provinciaError}</FormHelperText>
        </FormControl>

      </Grid>



      <Grid item xs={4}>


        <FormControl size="small" fullWidth error={hasError(comunaError)} disabled={ciudad === '0a' ? true : false}>
          <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
            {"Comuna"}
          </InputLabel>
          <Select
            disabled={ciudad === '0a' ? true : false}
            value={comuna}
            native
            label="Comuna"
            id="grouped-native-select"
            fullWidth
            variant='outlined'
            style={{ color: hasError(comunaError) ? 'red' : 'inherit' }}
            onChange={(e) => {
              setNumeroCalle('')
              setNombreCalle('')
              if (e.target.value !== '0a') {
                setComuna(e.target.value);
                setComunaError('')
                setNombreCalleError('Campo obligatorio')
                setNumeroCalleError('Campo obligatorio')
              } else {
                setComuna('0a');

              }
            }}
          >
            <option key={'0a'} value={'0a'}>Seleccione</option>
            {
              listaComunas.length === 0 ? null :
                getOptionsComunas()
            }
          </Select>
          <FormHelperText>{comunaError}</FormHelperText>
        </FormControl>

      </Grid>

      <Grid item xs={4}>
        <AppTextInput
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          size={'small'}
          variant="outlined"
          label="Nombre Calle"
          disabled={comuna === '0a' ? true : false}
          value={nombreCalle}
          onChange={e => {
            if (e.target.value.length < 100) {
              setNombreCalle(e.target.value);
              if (e.target.value === '') {
                setNumeroCalle('')
              }
            }

          }}
          helperText={nombreCalleError}
          onBlur={() => {
            validateField(nombreCalle, setNombreCalleError)
            if (validateField(numeroCalle, setNumeroCalleError)) {
              let comunaName = listaComunas.find(com => com.comuna_id === parseInt(comuna))
              setDireCompleta(nombreCalle + ' ' + numeroCalle + ' ' + comunaName.comuna_nombre)
            }
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <AppTextInput
          tooltip={'El formato debe ser 1111 o "s/n"'}
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          size={'small'}
          variant="outlined"
          helperText={numeroCalleError}
          label="Nº"
          disabled={nombreCalle === '' ? true : false}
          value={numeroCalle}
          onChange={e => {
            //const regex = /^[0-9]+$/;
            // if (regex.test(e.target.value) || e.target.value === '') {
            if (e.target.value.length < 8) {
              if(validateNCalle(e.target.value)){
                setNumeroCalle(e.target.value)
              }

            }
            // }

          }}
          onBlur={() => {
            validateField(numeroCalle, setNumeroCalleError)
            if (validateField(numeroCalle, setNumeroCalleError)) {
              let comunaName = listaComunas.find(com => com.comuna_id === parseInt(comuna))
              setDireCompleta(nombreCalle + ' ' + numeroCalle + ' ' + comunaName.comuna_nombre)
            }
          }}
        />
      </Grid>
      {
        listaServiciosSalud.length === 0 ?
          null
          :
          <Grid item xs={4}>
            <FormControl size="small" fullWidth error={hasError(servicioSaludError)}>
              <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                {"Servicio de Salud"}
              </InputLabel>
              <Select
                value={servicioSalud}
                native
                label="Servicio de Salud"
                id="grouped-native-select"
                fullWidth
                style={{ color: hasError(servicioSaludError) ? 'red' : 'inherit' }}
                variant='outlined'
                onChange={(e) => {

                  if (e.target.value !== '0a') {
                    setServicioSalud(e.target.value);
                    setServicioSaludError('')
                  } else {
                    setServicioSalud('0a');
                    setServicioSaludError('Campo obligatorio')
                  }
                }}
              >
                <option key={'0a'} value={'0a'}>Seleccione</option>
                {
                  getServiciosSaludOpts()
                }
              </Select>
              <FormHelperText>{servicioSaludError}</FormHelperText>
            </FormControl>
          </Grid>
      }
    </Grid>
  );
};

export default DireccionPrestador;
